export default {
  title: 'Components batch 1/Breadcrumb',
  tags: ['autodocs'],
  argTypes: {
    design: {
      control: { type: 'select' },
      options: ['text', 'icon-text', 'icon'],
      description: 'Design of the breadcrumbs',
    },
    separator: {
      control: { type: 'select' },
      options: ['chevron-right', 'slash'],
      description: 'Separator style of the breadcrumbs',
    },
    custom_class: {
      control: { type: 'text' },
    },
    component_mode: {
      control: { type: 'check' },
      options: ['light-mode'],
      description: 'Mode of the breadcrumb component',
    }
  },
  parameters: {
    docs: {
      description: {
        component: `
To use the \`dda-breadcrumb\` component, pass the following props:

\`\`\`html
<dda-breadcrumb
    design="text"
    separator="chevron-right"
    custom_class=""
    component_mode=""
    data-breadcrumbs='[{"text":"Home","icon":"fa-house","url":"/"},
                        {"text":"Library","icon":"fa-book","url":"/library"},
                        {"text":"Data","icon":"fa-database"}]'
></dda-breadcrumb>
  \`\`\`
`,
      },
    },
  },
};

const Template = (args) => {
  const { breadcrumbs, ...otherArgs } = args;
  const attributes = Object.entries(otherArgs)
    .filter(([key, value]) => value !== undefined && key !== 'text')
    .map(([key, value]) => `${key}="${value}"`)
    .join(' ');

  const breadcrumbsData = JSON.stringify(breadcrumbs);

  return `<dda-breadcrumb ${attributes} data-breadcrumbs='${breadcrumbsData}'></dda-breadcrumb>`;
};


export const TextOnly = Template.bind({});
TextOnly.args = {
  design: 'text',
  separator: 'chevron-right',
  breadcrumbs: [
    { text: 'Home', icon: 'fa-house', url: '/' },
    { text: 'Library', icon: 'fa-book', url: '/library' },
    { text: 'Data', icon: 'fa-database' },
  ],
  custom_class: '',
  component_mode: '',
};

export const IconText = Template.bind({});
IconText.args = {
  design: 'icon-text',
  separator: 'chevron-right',
  breadcrumbs: [
    { text: 'Home', icon: 'fa-house', url: '/' },
    { text: 'Library', icon: 'fa-book', url: '/library' },
    { text: 'Data', icon: 'fa-database' },
  ],
  custom_class: '',
  component_mode: '',
};

export const IconOnly = Template.bind({});
IconOnly.args = {
  design: 'icon',
  separator: 'chevron-right',
  breadcrumbs: [
    { text: 'Home', icon: 'fa-house', url: '/' },
    { text: 'Library', icon: 'fa-book', url: '/library' },
    { text: 'Data', icon: 'fa-database' },
  ],
  custom_class: '',
  component_mode: '',
};
